import { Button } from 'antd';
import React, { FC } from 'react';
import { Account, AccountType } from '../../dto';
import { EditOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { useBusinessContext } from '../../context/BusinessContext';

type Props = {
  accountType: AccountType;
  accounts: Account[];
  onAddNew: () => void;
  onEdit: (account: Account) => void;
};

const AccountSection: FC<{ account: Account; onEdit: () => void }> = ({
  account,
  onEdit,
}) => {
  return (
    <div className="w-full flex flex-col md:flex-row gap-2 py-2 px-4 border-0 border-b border-b-slate-300 border-solid">
      <div className="grow-0 shrink-0 w-[100px] break-all">
        {account.displayId}
      </div>
      <div className="grow-0 shrink-0 w-[300px]">
        <div>{account.name}</div>
        <div className="text-sm text-slate-500">
          No transactions for this account
        </div>
      </div>
      <div className="grow shrink">{account.description}</div>
      <div className="grow-0 shrink-0">
        <Button type="link" onClick={onEdit}>
          <EditOutlined />
        </Button>
      </div>
    </div>
  );
};

export const AccountTypeSection: FC<Props> = (props) => {
  const { accounts, accountType, onAddNew } = props;
  return (
    <div className="w-full flex flex-col">
      <div className="w-full py-2 px-4 bg-primary-25 font-bold text-lg">
        {accountType.name}
      </div>
      {accounts.map((acc) => (
        <AccountSection
          key={acc.accountId}
          account={acc}
          onEdit={() => props.onEdit(acc)}
        />
      ))}
      {accountType.allowAdd && (
        <div className="pl-[108px]">
          <Button type="link" icon={<PlusCircleOutlined />} onClick={onAddNew}>
            Add a new Account
          </Button>
        </div>
      )}
    </div>
  );
};
